/**
 * The decision KPI band that opens the benchmark report (2026-09-08).
 *
 * Per the `dataviz` form heuristic: "a handful of headline numbers -> KPI row of
 * stat tiles, NOT a grouped bar chart". These five numbers are the report's
 * answer to "so what do I do?", and none of them existed as a number anywhere in
 * the report before — they were latent in tables the reader had to do arithmetic
 * against.
 *
 * Every value is derived in `@aurora/shared`'s `reportKpis`, so the Markdown
 * deliverable states the identical numbers.
 */
import type { BenchmarkKpi } from '@aurora/shared';

export function KpiBand({
  kpis,
  note,
}: {
  kpis: BenchmarkKpi[];
  note?: string;
}): JSX.Element | null {
  if (kpis.length === 0) return null;
  return (
    <section className="kpi-band-wrap">
      <div className="kpi-band">
        {kpis.map((k) => (
          <div key={k.key} className={`kpi-tile kpi-tone-${k.tone}`}>
            <div className="kpi-label">
              {k.label}
              {k.audience === 'internal' && (
                <span className="kpi-internal" title="Internal view only — not shown in the client view of this report">
                  internal
                </span>
              )}
            </div>
            <div className="kpi-value">{k.value}</div>
            <div className="kpi-detail">{k.detail}</div>
          </div>
        ))}
      </div>
      {note && <p className="muted kpi-band-note">{note}</p>}
    </section>
  );
}
